import { Dispatch, SetStateAction } from 'react'

export function createFieldSetter<T, K extends keyof NonNullable<T>>(
  key: K,
  baseSetter: Dispatch<SetStateAction<T>>
): Dispatch<SetStateAction<undefined | NonNullable<T>[K]>> {
  return (valueOrUpdater) => {
    baseSetter((prev) => {
      // If prev is null/undefined, create a default object
      const base = (prev ?? {}) as NonNullable<T>
      type FieldValue = NonNullable<T>[K]
      const newValue =
        typeof valueOrUpdater === 'function'
          ? (valueOrUpdater as (prev: FieldValue) => FieldValue)(base[key])
          : valueOrUpdater
      return {
        ...base,
        [key]: newValue,
      } as T
    })
  }
}

export function createFieldSetterWithDefault<T, K extends keyof NonNullable<T>>(
  key: K,
  baseSetter: Dispatch<SetStateAction<T>>,
  defaultValue: NonNullable<T>[K]
): Dispatch<SetStateAction<NonNullable<T>[K]>> {
  const fieldSetter = createFieldSetter(key, baseSetter)
  return (valueOrUpdater) => {
    if (typeof valueOrUpdater === 'function') {
      fieldSetter((prev) => {
        const newValue = (
          valueOrUpdater as (
            prev: NonNullable<T>[K] | undefined
          ) => NonNullable<T>[K]
        )(prev ?? defaultValue)
        return newValue
      })
    } else {
      fieldSetter(valueOrUpdater)
    }
  }
}
